import { Centered } from '@servicetitan/cp-ui';
import { BodyText, Headline, Icon } from '@servicetitan/design-system';
import { provide, useDependencies } from '@servicetitan/react-ioc';
import { tokens } from '@servicetitan/tokens';
import { FC, useEffect } from 'react';
import { AppErrorStore } from '../../stores/app-error.store';

export const AppError: FC = provide({ singletons: [AppErrorStore] })(() => {
    const [{ logAppError }] = useDependencies(AppErrorStore);

    useEffect(() => {
        logAppError();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <Centered fullPage className="p-x-3">
            <Icon name="warning" color={tokens.colorRed500} className="m-b-2" size={48} />
            <Headline size="large" className="ta-center">
                Oops! Something went wrong
            </Headline>
            <BodyText size="medium" subdued className="ta-center">
                Please reload the page and try again. If the problem persists, please contact
                support.
            </BodyText>
        </Centered>
    );
});
